export const Categories = [
    'Medicine',
    'Consumer Running Products',
    'Tablets',
    'Surgical Product'
]